/**
 * Utilidades para el manejo de fechas en la aplicación
 */

/**
 * Obtiene la fecha y hora actual en formato ISO
 * @returns {string} Fecha y hora en formato ISO
 */
export const getCurrentDateTimeISO = () => {
    return new Date().toISOString();
};

/**
 * Formatea una fecha ISO a formato legible (DD/MM/YYYY)
 * @param {string} isoDate - Fecha en formato ISO
 * @returns {string} - Fecha formateada o '-' si no es válida
 */
export const formatDate = (isoDate) => {
    if (!isoDate) return "-";

    const date = new Date(isoDate);

    // Validate date
    if (isNaN(date.getTime())) return "-";

    // Min date 01/01/0001
    if (date.getFullYear() <= 1) return "-";

    return date.toLocaleDateString('es-ES', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        timeZone: 'UTC'
    });
};

/**
 * Convierte una fecha de formato DD/MM/YYYY a formato ISO
 * @param {string} dateString - Fecha en formato DD/MM/YYYY
 * @returns {string} - Fecha en formato ISO o null si es inválida
 */
export const dateStringToISO = (dateString) => {
    if (!dateString) return null;

    try {
        const parts = dateString.split('/');
        if (parts.length !== 3) return null;

        const day = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10) - 1; // Los meses en JS son 0-11
        const year = parseInt(parts[2], 10);

        const date = new Date(year, month, day);
        return date.toISOString();
    } catch (error) {
        console.error("Error al convertir fecha:", error);
        return null;
    }
}; 